import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Nav from "./components/Nav";
import Landing from "./pages/Landing";
import Start from "./pages/Start";
import Checkout from "./pages/Checkout";
import Assessment from "./pages/Assessment";
import PersonalReport from "./pages/PersonalReport";
import InviteSend from "./pages/InviteSend";
import InviteLanding from "./pages/InviteLanding";
import Combination from "./pages/Combination";
import Dashboard from "./pages/Dashboard";
import Ebook from "./pages/Ebook";
import Teams from "./pages/Teams";
import TeamDetail from "./pages/TeamDetail";
import TeamJoin from "./pages/TeamJoin";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#FAF7F2]">
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/start" element={<Start />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/report/:id" element={<PersonalReport />} />
            <Route path="/invite" element={<InviteSend />} />
            <Route path="/invite/:token" element={<InviteLanding />} />
            <Route path="/combination/:id" element={<Combination />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/team/join/:token" element={<TeamJoin />} />
            <Route path="/team/:id" element={<TeamDetail />} />
            <Route path="/ebook" element={<Ebook />} />
          </Routes>
        </div>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
